export const agentStateHistory = [
  {
    stateIndex: 1,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Lunch',
    duration: 48,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 2,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 11,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 3,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 27,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 4,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 53,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 5,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 29,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 6,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 15,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 7,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Break',
    duration: 42,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 8,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 34,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 9,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 49,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 10,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 16,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 11,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 33,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 12,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 25,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 13,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 20,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 14,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 39,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 15,
    startDate: 'today', //"2022-09-08T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 22,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 16,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 9,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 17,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 51,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 18,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 45,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 19,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 35,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 20,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 46,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 21,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 43,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 22,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 43,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 23,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 31,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 24,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 1,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 25,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Lunch',
    duration: 55,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 26,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Lunch',
    duration: 13,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 27,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 47,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 28,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 48,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 29,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 18,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 30,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 25,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 31,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 31,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 32,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Break',
    duration: 2,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 33,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 24,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 34,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 28,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 35,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 14,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 36,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 20,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 37,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 44,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 38,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Coaching',
    duration: 32,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 39,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundConsult',
    duration: 11,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 40,
    startDate: 'yesterday', //"2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundConsult',
    duration: 41,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 41,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 18,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 42,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 54,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 43,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 13,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 44,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Break',
    duration: 58,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 45,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'outboundConsult',
    duration: 25,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 46,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'outboundConsult',
    duration: 9,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 47,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Lunch',
    duration: 9,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 48,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 12,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 49,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 48,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 50,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 42,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 51,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 51,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 52,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 13,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 53,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 7,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 54,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 48,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 55,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 45,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 56,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 28,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 57,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 22,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 58,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 56,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 59,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 29,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 60,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 43,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 61,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 19,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 62,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 19,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 63,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 11,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 64,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundConsult',
    duration: 29,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 65,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundConsult',
    duration: 56,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 66,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 12,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 67,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 58,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 68,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 12,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 69,
    startDate: 'last7days', //"2022-08-31T00:00:00.000Z" - "2022-09-07T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Break',
    duration: 44,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 70,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'outboundConsult',
    duration: 31,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 71,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'outboundConsult',
    duration: 55,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 72,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 17,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 73,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 10,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 74,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 4,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 75,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 0,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 76,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 9,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 77,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'OutboundContact',
    duration: 49,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 78,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 57,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 79,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 11,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 80,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 34,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 81,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 23,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 82,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 31,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 83,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 48,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 84,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 11,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 85,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 32,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 86,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Lunch',
    duration: 38,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 87,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundConsult',
    duration: 57,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 88,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundConsult',
    duration: 36,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 89,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 58,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 90,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 13,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 91,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 22,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 92,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'unavailable',
    duration: 47,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 93,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'outboundConsult',
    duration: 33,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 94,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'outboundConsult',
    duration: 45,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 95,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 6,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 96,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 54,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 97,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 56,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 98,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Lunch',
    duration: 56,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 99,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'working',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 56,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 100,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'inboundContact',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'inboundContact',
    duration: 38,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 101,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 10,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 101,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 10,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 102,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'available',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: '',
    duration: 37,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
  {
    stateIndex: 103,
    startDate: 'custom', //"2022-08-31T00:00:00.000Z" - "2022-09-30T00:00:00.000Z",
    agentStateId: 2,
    agentStateName: 'unavailable',
    agentSessionId: 450387337,
    skillId: null,
    skillName: null,
    mediaTypeId: null,
    mediaTypeName: null,
    fromAddress: null,
    toAddress: null,
    outStateId: 1073741852,
    outStateDescription: 'Coaching',
    duration: 4,
    isOutbound: null,
    isNaturalCalling: null,
    stationId: null,
    stationName: null,
  },
];

export const agentPerformance = [
  {
    type: 'today',
    agentId: '252267',
    teamId: '10',
    inboundHandled: '0',
    outboundHandled: '4',
    totalHandled: '4',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '',
    outboundTalkTime: '',
    outboundAvgTalkTime: '',
    totalTalkTime: '',
    totalAvgTalkTime: 'P',
    totalAvgHandleTime: '.',
    consultTime: '',
    availableTime: '',
    unavailableTime: '',
    acwTime: '',
    refused: '0',
    percentRefused: '',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
  {
    type: 'yesterday',
    agentId: '252267',
    teamId: '10',
    inboundHandled: '1',
    outboundHandled: '5',
    totalHandled: '6',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '',
    outboundTalkTime: '',
    outboundAvgTalkTime: '',
    totalTalkTime: '',
    totalAvgTalkTime: 'P',
    totalAvgHandleTime: '.',
    consultTime: '',
    availableTime: '',
    unavailableTime: '',
    acwTime: '',
    refused: '0',
    percentRefused: '',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
  {
    type: 'last7days',
    agentId: '252267',
    teamId: '10',
    inboundHandled: '11',
    outboundHandled: '98',
    totalHandled: '109',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '',
    outboundTalkTime: '',
    outboundAvgTalkTime: '',
    totalTalkTime: '',
    totalAvgTalkTime: 'P',
    totalAvgHandleTime: '.',
    consultTime: '',
    availableTime: '',
    unavailableTime: '',
    acwTime: '',
    refused: '0',
    percentRefused: '',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
  {
    type: 'custom',
    agentId: '252267',
    teamId: '10',
    inboundHandled: '79',
    outboundHandled: '301',
    totalHandled: '380',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '',
    outboundTalkTime: '',
    outboundAvgTalkTime: '',
    totalTalkTime: '',
    totalAvgTalkTime: 'P',
    totalAvgHandleTime: '.',
    consultTime: '',
    availableTime: '',
    unavailableTime: '',
    acwTime: '',
    refused: '0',
    percentRefused: '',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
];

export const teamPerformance = [
  {
    type: 'today',
    teamId: '10',
    inboundHandled: '10',
    outboundHandled: '20',
    totalHandled: '30',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '0',
    outboundTalkTime: '0',
    outboundAvgTalkTime: '0',
    totalAvgHandled: '0',
    totalTalkTime: '0',
    totalAvgTalkTime: '0',
    totalAvgHandleTime: '0',
    consultTime: '0',
    availableTime: '0',
    unavailableTime: '0',
    avgavailableTime: '0',
    avgunavailableTime: '0',
    acwTime: '0',
    refused: '0',
    percentRefused: '0',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
  {
    type: 'yesterday',
    teamId: '10',
    inboundHandled: '12',
    outboundHandled: '18',
    totalHandled: '30',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '0',
    outboundTalkTime: '0',
    outboundAvgTalkTime: '0',
    totalAvgHandled: '0',
    totalTalkTime: '0',
    totalAvgTalkTime: '0',
    totalAvgHandleTime: '0',
    consultTime: '0',
    availableTime: '0',
    unavailableTime: '0',
    avgavailableTime: '0',
    avgunavailableTime: '0',
    acwTime: '0',
    refused: '0',
    percentRefused: '0',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
  {
    type: 'last7days',
    teamId: '10',
    inboundHandled: '128',
    outboundHandled: '331',
    totalHandled: '459',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '0',
    outboundTalkTime: '0',
    outboundAvgTalkTime: '0',
    totalAvgHandled: '0',
    totalTalkTime: '0',
    totalAvgTalkTime: '0',
    totalAvgHandleTime: '0',
    consultTime: '0',
    availableTime: '0',
    unavailableTime: '0',
    avgavailableTime: '0',
    avgunavailableTime: '0',
    acwTime: '0',
    refused: '0',
    percentRefused: '0',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
  {
    type: 'custom',
    teamId: '10',
    inboundHandled: '604',
    outboundHandled: '759',
    totalHandled: '1363',
    agentOffered: '0',
    inboundTime: '0',
    inboundTalkTime: '0',
    inboundAvgTalkTime: '0',
    outboundTime: '0',
    outboundTalkTime: '0',
    outboundAvgTalkTime: '0',
    totalAvgHandled: '0',
    totalTalkTime: '0',
    totalAvgTalkTime: '0',
    totalAvgHandleTime: '0',
    consultTime: '0',
    availableTime: '0',
    unavailableTime: '0',
    avgavailableTime: '0',
    avgunavailableTime: '0',
    acwTime: '0',
    refused: '0',
    percentRefused: '0',
    loginTime: '',
    workingRate: '',
    occupancy: '100.00',
  },
];
